import { render, staticRenderFns } from "./indexCf.vue?vue&type=template&id=33df1765&scoped=true"
import script from "./indexCf.vue?vue&type=script&lang=js"
export * from "./indexCf.vue?vue&type=script&lang=js"
import style0 from "./indexCf.vue?vue&type=style&index=0&id=33df1765&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33df1765",
  null
  
)

export default component.exports